<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm bảng giá tính lương</div>
      <div v-else>Chỉnh sửa bảng giá tính lương</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Mã văn phòng*</label>
          <div class="p-col-10">
            <Dropdown id="office_tpl_id" :showClear="true" :filter="true" :disabled="this.disableEdit"
              v-model="office_tpl_id" :options="listOfficeTpl" optionLabel="code" @change="onChangetpl($event)"
              placeholder="Chọn 1 mã văn phòng"/>
              <small
                v-if="validationErrors && validationErrors['office_tpl_id']"
                class="p-invalid"
              >{{validationErrors['office_tpl_id']}}</small>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Quận/ Huyện</label>
          <!-- <label class="p-col-2 txt-left">Quận/ Huyện*</label> -->
          <div class="p-col-10" v-if="this.mode !== 'edit'">
            <Dropdown id="district_id" :showClear="true" :filter="true" :disabled="this.disabletpl"
              v-model="selectedDistrict" :options="this.listDistrict" @change="onChangeDistrict($event)"
              optionLabel="name_with_state"
              placeholder="Chọn 1 Quận/ Huyện"/>
              <small
                v-if="validationErrors && validationErrors['district_id']"
                class="p-invalid"
              >{{validationErrors['district_id']}}</small>
          </div>
          <div class="p-col-10" v-else>
            <Dropdown id="district_id" :showClear="true" :filter="true" :disabled="this.disableEdit"
              v-model="selectedDistrict" :options="this.listDistrict"
              optionLabel="name_with_state"/>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <label class="p-col-2 txt-left">Phường*</label>
          <div class="p-col-10" v-if="this.mode !== 'edit'">
            <MultiSelect v-model="selectedWard" :options="this.listWard" :disabled="this.disabledWard"
              optionLabel="name_with_district" placeholder="Chọn 1 hoặc nhiều Phường" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['ward_id']"
                class="p-invalid"
              >{{validationErrors['ward_id']}}</small>
          </div>
          <div v-else class="p-col-10">
            <InputText id="ward_name" :disabled="this.disableEdit"
              v-model="ward_name" /> 
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-2"></div>
          <label class="p-col-5 txt-left" style="font-weight: bold;">Thường</label>
          <label class="p-col-5 txt-left" style="font-weight: bold;">Trễ</label>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-2 txt-left">Văn bản loại 1*</label>
          <div class="p-col-5">
            <InputNumber v-model="type1_normal" mode="currency" currency="VND" locale="vi-VN"
            />
          </div>
          <div class="p-col-5">
            <InputNumber v-model="type1_late" mode="currency" currency="VND" locale="vi-VN"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-2 txt-left">Văn bản loại 2*</label>
          <div class="p-col-5">
            <InputNumber v-model="type2_normal" mode="currency" currency="VND" locale="vi-VN"
            />
          </div>
          <div class="p-col-5">
            <InputNumber v-model="type2_late" mode="currency" currency="VND" locale="vi-VN"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-2 txt-left">Văn bản loại 3*</label>
          <div class="p-col-5">
            <InputNumber v-model="type3_normal" mode="currency" currency="VND" locale="vi-VN" disabled="true"
            />
          </div>
          <div class="p-col-5">
            <InputNumber v-model="type3_late" mode="currency" currency="VND" locale="vi-VN" disabled="true"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-2 txt-left">Văn bản loại 4*</label>
          <div class="p-col-5">
            <InputNumber v-model="type4_normal" mode="currency" currency="VND" locale="vi-VN" disabled="true"
            />
          </div>
          <div class="p-col-5">
            <InputNumber v-model="type4_late" mode="currency" currency="VND" locale="vi-VN" disabled="true"
            />
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
import graphql from "@/views/admin/common/graphql";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      disabledWard: true,
      disableEdit: false,
      disabletpl: true,
      selectedWard: [],
      listWard: [],
      selectedDistrict: null,
      listDistrict: [],
      type1_normal: 0,
      type1_late: 0,
      type2_normal: 0,
      type2_late: 0,
      type3_normal: 0,
      type3_late: 0,
      type4_normal: 0,
      type4_late: 0,
      office_tpl_id: null,
      listOfficeTpl: [],
      ward_id: null,
      ward_name: '',
      listSalaryPricelist: [],
      salary_pricelist_id: null
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.salary_pricelist_id = this.$route.params.id
      this.disableEdit = true
    }
    if (this.mode == 'edit') {
      this.disableEdit = true
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async onChangeDistrict(e) {
      console.log('e', e)
      this.selectedWard = []
      this.listWard = []
      if (e) {
        await this.getWard(e.value);
      } else {
        this.disabledWard = true
      }
    },
    async onChangetpl(e) {
      console.log('e', e)
      this.selectedDistrict = null
      this.selectedWard = []
      this.listWard = []
      this.disabledWard = false
      console.log('this.office_tpl_id')
      await this.getWard(null);
      if (e && e.value != null) {
        this.disabletpl = false
      } else {
        this.disabletpl = true
      }
    },
    async getWard(district) {
      if(this.office_tpl_id == null){
        this.listWard = []
        this.disabledWard = true
        return
      }
      //if (district) {
      var where_ward = ``;
      if (district) {
        where_ward = `district_id: {_eq: $district_id}`;
      }else{
        where_ward = `state_merger: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}}`;
      }
      var where_salary_pricelist = ``;
      if (district) {
        where_salary_pricelist = `district_id: {_eq: $district_id}, office_tpl_id: {_eq: $office_tpl_id}`;
      }else{
      //  where_salary_pricelist = `state_merger: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}`;
        where_salary_pricelist = `office_tpl_id: {_eq: $office_tpl_id}`;
      }
      var str_variables = `$district_id: Int!, $office_tpl_id: Int!`;

        var data_variables = {}
        if (district) {
          data_variables['district_id'] = district.id
        }else{
          str_variables = `$office_tpl_id: Int!`;
          //data_variables['district_id'] = 0
        }
        data_variables['office_tpl_id'] = this.office_tpl_id.id

        let query = `query MyQuery(${str_variables}) {
          ward(where: {${where_ward}}) {
            id
            name_with_district
          }
          salary_pricelist(where: {${where_salary_pricelist}}) {
            ward_id
          }
        }`
        
        await this.$apollo
          .query({
            query: gql(query),
            variables:data_variables
          })
          .then(async (res) => {
            console.log('res', res)
            if (res.data.ward.length > 0) {
              this.listWard = res.data.ward
              this.disabledWard = false
              if (res.data.salary_pricelist.length >0) {
                for (let i = 0; i < res.data.salary_pricelist.length; i++) {
                  const e = res.data.salary_pricelist[i];
                  console.log("asdasdasd:",e)
                  this.listWard = this.listWard.filter((elem) => elem.id !== e.ward_id)
                }
              }
            } else {
              this.listWard = []
              this.disabledWard = true
            }
        })
      // } else {
      //   this.listWard = []
      //   this.disabledWard = true
      // }
    },
    async validateData() {
      this.validationErrors = {};
      var has_error = false
      if (this.mode == 'add') {
        if (!this.office_tpl_id) {
          this.validationErrors['office_tpl_id'] = 'Vui lòng chọn mã văn phòng';
          has_error = true
        }
        // if (!this.selectedDistrict) {
        //   this.validationErrors['district_id'] = 'Vui lòng chọn quận/huyện';
        //   has_error = true
        // }
        if (this.selectedWard.length == 0) {
          this.validationErrors['ward_id'] = 'Vui lòng chọn phường';
          has_error = true
        }
      }
      
      return has_error
    },
    async analyzeData() {
        var data_item= []

        for (let i = 0; i < this.selectedWard.length; i++) {
          const item = this.selectedWard[i]
          var data_item_item= {}
          data_item_item['office_tpl_id'] = this.office_tpl_id.id
          data_item_item['district_id'] = (!this.$commonFuction.isEmpty(this.selectedDistrict)) ? this.selectedDistrict.id : null
          data_item_item['ward_id'] = item.id
          data_item_item['type1_normal'] = this.type1_normal
          data_item_item['type1_late'] = this.type1_late
          data_item_item['type2_normal'] = this.type2_normal
          data_item_item['type2_late'] = this.type2_late
          data_item_item['type3_normal'] = this.type3_normal
          data_item_item['type3_late'] = this.type3_late
          data_item_item['type4_normal'] = this.type4_normal
          data_item_item['type4_late'] = this.type4_late
          data_item.push(data_item_item)
        }

      return data_item
    },
    async analyzeDataEdit() {
      var data_salary_pricelist = {}
        data_salary_pricelist['type1_normal'] = this.type1_normal
        data_salary_pricelist['type1_late'] = this.type1_late
        data_salary_pricelist['type2_normal'] = this.type2_normal
        data_salary_pricelist['type2_late'] = this.type2_late
        data_salary_pricelist['type3_normal'] = this.type3_normal
        data_salary_pricelist['type3_late'] = this.type3_late
        data_salary_pricelist['type4_normal'] = this.type4_normal
        data_salary_pricelist['type4_late'] = this.type4_late
      return data_salary_pricelist
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_salary_pricelist = await this.analyzeData()

        var query = `mutation MyMutation($objects: [salary_pricelist_insert_input!]!) {
            insert_salary_pricelist(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: data_salary_pricelist
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-salary_pricelist'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_salary_pricelist_update = await this.analyzeDataEdit()
        let query = `mutation MyMutation($salary_pricelist_id: Int!, $salary_pricelist_update: salary_pricelist_set_input) {
          update_salary_pricelist(where: {id: {_eq: $salary_pricelist_id}}, _set: $salary_pricelist_update) {
            affected_rows
            returning {
              id
            }
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              salary_pricelist_id: this.salary_pricelist_id,
              salary_pricelist_update: data_salary_pricelist_update,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-salary_pricelist'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    district: {
      query() {
        let query = `
          query MyQuery {
            district(where: {state: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}}}) {
              id
              name_with_state
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.district){
         // this.listDistrict = data.district
          var list_district = [];
          list_district.push({id: null, name_with_state: '--none--'})
          for(let i = 0; i < data.district.length; i++) {
            list_district.push(data.district[i])
          }
          this.listDistrict = list_district
          console.log('this.listDistrict', this.listDistrict)
        }
      },
      fetchPolicy: "network-only"
    },
    office_tpl: {
      query() {
        let query = graphql.GET_OFFICE_TPL_COMMON
        return gql(query);
      },
      update(data) {
        if(data.office_tpl){
          this.listOfficeTpl = data.office_tpl
        }
      },
      fetchPolicy: "network-only",
    },
    salary_pricelist: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            salary_pricelist(where: {id: {_eq: $id}}) {
              id
              type1_normal
              type1_late
              type2_normal
              type2_late
              type3_normal
              type3_late
              type4_normal
              type4_late
              office_tpl {
                id
                code
              }
              district {
                id
                name_with_state 
              }
              ward {
                id
                name_with_district
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      async update(data) {
        if(data.salary_pricelist){
          this.listSalaryPricelist = data.salary_pricelist
          this.office_tpl_id = this.listSalaryPricelist[0].office_tpl
          this.selectedDistrict = this.listSalaryPricelist[0].district
          
          this.type1_normal = this.listSalaryPricelist[0].type1_normal
          this.type1_late = this.listSalaryPricelist[0].type1_late
          this.type2_normal = this.listSalaryPricelist[0].type2_normal
          this.type2_late = this.listSalaryPricelist[0].type2_late
          this.type3_normal = this.listSalaryPricelist[0].type3_normal
          this.type3_late = this.listSalaryPricelist[0].type3_late
          this.type4_normal = this.listSalaryPricelist[0].type4_normal
          this.type4_late = this.listSalaryPricelist[0].type4_late
          this.ward_name = this.listSalaryPricelist[0].ward.name_with_district
          this.ward_id = this.listSalaryPricelist[0].ward.id
          this.salary_pricelist_id = this.listSalaryPricelist[0].id
          console.log('this.ward_id', this.ward_id)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
